'use client';

import {useState} from 'react';
import {useTranslation} from 'react-i18next';

const NEARBY_INLINE_LIMIT = 6;

export interface DetailNearbyPlace {
  icon?: string;
  label: string;
  time: string;
}

export interface DetailModalsInput {
  amenities: {icon: string; label: string}[];
  nearby: {icon?: string; label: string; minutes: number}[];
}

export interface DetailModals {
  amenitiesOpen: boolean;
  nearbyOpen: boolean;
  amenitiesOverflow: boolean;
  nearbyOverflow: boolean;
  openAmenities: () => void;
  closeAmenities: () => void;
  openNearby: () => void;
  closeNearby: () => void;
  nearbyPlaces: DetailNearbyPlace[];
  inlineNearbyPlaces: DetailNearbyPlace[];
}

export function useDetailModals(input: DetailModalsInput): DetailModals {
  const {t} = useTranslation();
  const [amenitiesOpen, setAmenitiesOpen] = useState(false);
  const [nearbyOpen, setNearbyOpen] = useState(false);

  const nearbyPlaces: DetailNearbyPlace[] = input.nearby.map(place => ({
    icon: place.icon,
    label: place.label,
    time: t('n_min', {minutes: place.minutes}),
  }));

  return {
    amenitiesOpen,
    nearbyOpen,
    amenitiesOverflow: input.amenities.length > 1,
    nearbyOverflow: input.nearby.length > NEARBY_INLINE_LIMIT,
    openAmenities: () => {
      setAmenitiesOpen(true);
    },
    closeAmenities: () => {
      setAmenitiesOpen(false);
    },
    openNearby: () => {
      setNearbyOpen(true);
    },
    closeNearby: () => {
      setNearbyOpen(false);
    },
    nearbyPlaces,
    inlineNearbyPlaces: nearbyPlaces.slice(0, NEARBY_INLINE_LIMIT),
  };
}
